import { AutogenModelDrsPayeeEquip, AutogenRowDrsPayeeEquip } from "./autogen/AutogenModelDrsPayeeEquip";

export class ModelDrsPayeeEquip extends AutogenModelDrsPayeeEquip<RowDrsPayeeEquip> {
    constructor() {
        super(RowDrsPayeeEquip);
    }
}

export class RowDrsPayeeEquip extends AutogenRowDrsPayeeEquip {
}